import { Card, Form, Radio } from "antd";
import React, { useEffect } from "react";
import { isYounger } from "../../common";
import { ToothSample } from "../../models";
interface PropsType {
  editRecord: ToothSample;
  age: number;
}
export const AItem: React.FC<PropsType> = ({ editRecord, age }) => {
  const [form] = Form.useForm();
  useEffect(() => {
    if (editRecord.key !== -1) {
      form.setFieldsValue({ ...editRecord });
    } else {
      form.setFieldsValue({ a1: "否", a2: "否", a3: "否", a4: "否" });
    }
  }, [editRecord, form]);
  const onItemChange = (e: any) => {
    editRecord.a1 = form.getFieldValue("a1");
    editRecord.a2 = form.getFieldValue("a2");
    if (isYounger(age)) {
      editRecord.a3 = form.getFieldValue("a3");
      editRecord.a4 = form.getFieldValue("a4");
    }
  };
  return (
    <Card title="生物学因素" style={{ background: "#ececec", margin: "10px" }}>
      <Form
        layout="horizontal"
        labelCol={{ span: 18 }}
        wrapperCol={{ span: 6 }}
        form={form}
      >
        {isYounger(age) ? (
          <>
            <Form.Item name="a1" label="母亲或主要看护者过去12个月内患龋?">
              <Radio.Group onChange={onItemChange}>
                <Radio value={"是"}>是</Radio>
                <Radio value={"否"}>否</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item name="a2" label="儿童每天两次以上进食含糖食品或饮料?">
              <Radio.Group onChange={onItemChange}>
                <Radio value={"是"}>是</Radio>
                <Radio value={"否"}>否</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item name="a3" label="儿童每天含奶瓶入睡或睡前进食甜食?">
              <Radio.Group onChange={onItemChange}>
                <Radio value={"是"}>是</Radio>
                <Radio value={"否"}>否</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item name="a4" label="特殊健康护理需求?">
              <Radio.Group onChange={onItemChange}>
                <Radio value={"是"}>是</Radio>
                <Radio value={"否"}>否</Radio>
              </Radio.Group>
            </Form.Item>
          </>
        ) : (
          <>
            <Form.Item name="a1" label="儿童每天两次以上进食含糖食品或饮料?">
              <Radio.Group onChange={onItemChange}>
                <Radio value={"是"}>是</Radio>
                <Radio value={"否"}>否</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item name="a2" label="特殊健康护理需求?">
              <Radio.Group onChange={onItemChange}>
                <Radio value={"是"}>是</Radio>
                <Radio value={"否"}>否</Radio>
              </Radio.Group>
            </Form.Item>
          </>
        )}
      </Form>
    </Card>
  );
};
